module.exports = __webpack_public_path__ + "img/longImage1-compressor.0d851867.jpg";